"use client";

import { useRef, useEffect } from "react";
import styles from "../../styles/AboutUs.module.css";

const ValuesSection = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          } else {
            entry.target.classList.remove("visible");
          }
        });
      },
      { threshold: 0.3, rootMargin: "0px 0px -50px 0px" }
    );

    if (containerRef.current) observer.observe(containerRef.current);

    return () => {
      if (containerRef.current) observer.unobserve(containerRef.current);
    };
  }, []);

  return (
    <div className={styles.sliderContainer} style={{ 
      overflow: "hidden",
      width: "100%",
      position: "relative"
    }}>
      <h3 style={{ fontSize: "2.5em", marginTop: "0" }}>Our Values</h3>

      <div className={styles.ourValueSliderContainer} style={{ 
        overflow: "hidden",
        width: "100%",
        position: "relative", // Add this
        contain: "content" // Prevents layout shifts
      }} ref={containerRef}>
        <div className={styles.sliderWrapper} style={{
          position: "relative", // Add this
          width: "100%"
        }}>
          {/* Top two cards - slide from top */}
          <div className={styles.slideBox}>
            <h4 className={styles.titleStyle}>Liberating</h4>
            <h2 style={{ color: "black" }} className={styles.subtitleStyle}>
              Opening what could be
            </h2>
            <p style={{ color: "black" }} className={styles.paragraph}>
              Empower users to embrace digital commerce by emphasizing possibility and unlocking potential.
            </p>
          </div>

          <div className={styles.slideBox}>
            <h4 className={styles.titleStyle}>Transparent</h4>
            <h2 className={styles.subtitleStyle}>What you see is what you get</h2>
            <p style={{ color: "black" }} className={styles.paragraph}>
              Use straightforward language to ensure audiences feel informed and in control.
            </p>
          </div>

          {/* Bottom two cards - slide from bottom */}
          <div className={styles.slideBox}>
            <h4 className={styles.titleStyle}>Visionary</h4>
            <h2 className={styles.subtitleStyle}>Actualizing what we envision</h2>
            <p style={{ color: "black" }} className={styles.paragraph}>
              Highlight leadership in transforming digital finance with ambitious language.
            </p>
          </div>

          <div className={styles.slideBox}>
            <h4 className={styles.titleStyle}>Tenacious</h4>
            <h2 className={styles.subtitleStyle}>Determined and steadfast</h2>
            <p style={{ color: "black" }} className={styles.paragraph}>
              Use decisive language to demonstrate Arifpay's commitment to its purpose.
            </p>
          </div>
        </div>
      </div>

      {/* Smooth Reveal Animations */}
      <style jsx>{`
        /* Container fixes */
        .${styles.ourValueSliderContainer} {
          overflow: hidden !important;
        }
        
        .${styles.sliderWrapper} {
          overflow: hidden;
          position: relative;
        }

        .${styles.slideBox} {
          opacity: 0;
          overflow: hidden;
          transform: translateY(80px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
          will-change: transform, opacity; /* Optimize performance */
          position: relative; /* Keep it positioned normally */
        }

        /* First two from top */
        .${styles.sliderWrapper} > .${styles.slideBox}:nth-child(1),
        .${styles.sliderWrapper} > .${styles.slideBox}:nth-child(2) {
          transform: translateY(-80px);
        }

        /* Last two from bottom */
        .${styles.sliderWrapper} > .${styles.slideBox}:nth-child(3),
        .${styles.sliderWrapper} > .${styles.slideBox}:nth-child(4) {
          transform: translateY(80px);
        }

        /* When visible */
        .visible .${styles.slideBox} {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }

        /* Staggered Delays */
        .visible .${styles.slideBox}:nth-child(1) { transition-delay: 0.1s; }
        .visible .${styles.slideBox}:nth-child(2) { transition-delay: 0.3s; }
        .visible .${styles.slideBox}:nth-child(3) { transition-delay: 0.5s; }
        .visible .${styles.slideBox}:nth-child(4) { transition-delay: 0.7s; }
      `}</style>
    </div>
  );
};

export default ValuesSection;